// Test IDs for the dayna ❤ rachel chat-blog interface.
// Keys camelCase, values kebab-case <feature>-<element>.

export const CHAT = {
  page: 'chat-page',
  title: 'chat-title',
  feed: 'chat-feed',
  emptyState: 'chat-empty-state',
  postBubble: 'chat-post-bubble',
  postText: 'chat-post-text',
  postTranslation: 'chat-post-translation',
  postDivider: 'chat-post-divider',
  postImage: 'chat-post-image',
  postVideo: 'chat-post-video',
  postMediaOpen: 'post-media-open-button',
  postMediaDialog: 'post-media-dialog',
  audioPlayButton: 'audio-play-button',
  audioPauseButton: 'audio-pause-button',
  audioWaveform: 'audio-waveform',
  audioDuration: 'audio-duration',
  audioTranscript: 'audio-transcript',
  audioTranscriptWord: 'audio-transcript-word',
  audioTranscriptTranslation: 'audio-transcript-translation',
  composer: 'chat-composer',
  composerAttach: 'composer-attach-button',
  composerDictate: 'composer-dictation-button',
  composerRecord: 'composer-audio-record-button',
  composerInput: 'composer-text-input',
  composerSend: 'composer-send-button',
  composerAttachInput: 'composer-attach-input',
  attachmentStrip: 'composer-attachment-preview-strip',
  attachmentItem: 'composer-attachment-preview-item',
  attachmentRemove: 'composer-attachment-remove-button',
  audioPreview: 'composer-audio-preview',
  audioPreviewPlay: 'composer-audio-preview-play',
  audioPreviewDiscard: 'composer-audio-preview-discard',
  sparkleCanvas: 'sparkle-rain-canvas',
  customCursor: 'custom-cursor',
  cursorTrailCanvas: 'cursor-trail-canvas',
  recordingIndicator: 'composer-recording-indicator',
  bubbleTimes: 'chat-bubble-times',
  bubbleTimeLine: 'chat-bubble-time-line',
};
